import { Spin } from "antd";

type Props = {
  hideText?: boolean;
  className?: string;
};

export default function Loader({ hideText = false, className }: Props) {
  return (
    <div className={`h-14 ${className}`}>
      <Spin
        className="w-full py-8 text-primary"
        tip={!hideText && "Loading..."}
        size="default"
        rootClassName="text-primary"
      >
        <span />
      </Spin>
    </div>
  );
}
